module.exports = __webpack_public_path__ + "img/printer-white.f359e248.svg";